import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/layout/Layout";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import Terms from "./pages/legal/Terms";
import DataDeletion from "./pages/legal/DataDeletion";
import Dashboard from "./pages/Dashboard";
import Facturacion from "./pages/Facturacion";
import Movimientos from "./pages/Movimientos";
import Categorias from "./pages/Categorias";
import ClientesPagos from "./pages/ClientesPagos";
import FlujoCaja from "./pages/FlujoCaja";
import Pagos from "./pages/Pagos";
import Prioridades from "./pages/Prioridades";
import RentabilidadUnificado from "./pages/RentabilidadUnificado";
import EstadoResultados from "./pages/EstadoResultados";
// Configuracion removed - only super admin can add users

// Premium Modules
import Presupuestos from "./pages/modules/Presupuestos";
import Forecast from "./pages/modules/Forecast";
import Proyectos from "./pages/modules/Proyectos";
import Equipo from "./pages/modules/Equipo";
import ReportesAuto from "./pages/modules/ReportesAuto";
import AIAdvisor from "./pages/modules/AIAdvisor";

// Admin Pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEmpresas from "./pages/admin/AdminEmpresas";
import AdminMarcas from "./pages/admin/AdminMarcas";
import AdminClientes from "./pages/admin/AdminClientes";
import AdminUsuarios from "./pages/admin/AdminUsuarios";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          
          {/* Protected routes */}
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/facturacion" element={<Facturacion />} />
            <Route path="/movimientos" element={<Movimientos />} />
            <Route path="/categorias" element={<Categorias />} />
            <Route path="/clientes-pagos" element={<ClientesPagos />} />
            <Route path="/flujo-caja" element={<FlujoCaja />} />
            <Route path="/pagos" element={<Pagos />} />
            <Route path="/prioridades" element={<Prioridades />} />
            <Route path="/rentabilidad" element={<RentabilidadUnificado />} />
            <Route path="/estado-resultados" element={<EstadoResultados />} />
            {/* Configuracion removed - only super admin can add users */}
            
            {/* Premium Module routes */}
            <Route path="/presupuestos" element={<Presupuestos />} />
            <Route path="/forecast" element={<Forecast />} />
            <Route path="/proyectos" element={<Proyectos />} />
            <Route path="/equipo" element={<Equipo />} />
            <Route path="/reportes-auto" element={<ReportesAuto />} />
            <Route path="/ai-advisor" element={<AIAdvisor />} />
            
            {/* Admin routes - Super Admin only */}
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/empresas" element={<AdminEmpresas />} />
            <Route path="/admin/empresas/:empresaId" element={<AdminMarcas />} />
            <Route path="/admin/marcas" element={<AdminMarcas />} />
            <Route path="/admin/clientes" element={<AdminClientes />} />
            <Route path="/admin/usuarios" element={<AdminUsuarios />} />
          </Route>
          
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
